const contentOverlay = document.getElementById("lq-more-content-overlay");
const footer = document.getElementById("wrapper-footer");
const moreButton = document.getElementById("lq-more-content-arrow");

moreButton.addEventListener("click", function () {
  const shouldGoUp = moreButton.classList.contains("lq-more-content-arrow--up");
  if (shouldGoUp) {
    // scroll to top
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  } else {
    // scroll 1 page height down
    window.scrollBy({
      top: window.innerHeight,
      behavior: "smooth",
    });
  }
});

function updateOverlay() {
  // check if footer is visible
  const footerRect = footer.getBoundingClientRect();
  const footerTop = footerRect.top;

  // check if footer top is less than scroll position + window height
  // if true, footer is visible
  if (footerTop < window.scrollY + window.innerHeight) {
    // hide overlay
    contentOverlay.style.opacity = 0;
    moreButton.classList.add("lq-more-content-arrow--up");
  } else {
    // show overlay
    contentOverlay.style.opacity = 1;
    moreButton.classList.remove("lq-more-content-arrow--up");
  }

  // check if full body is greater than 1.2 times window height
  // if true, show show button
  if (document.body.clientHeight > window.innerHeight * 1.2) {
    moreButton.style.display = "block";
  } else {
    moreButton.style.display = "none";
  }
}

// listen to scroll event of the full page
document.addEventListener("scroll", updateOverlay);

// listen to resize event of the full page
window.addEventListener("resize", updateOverlay);

// initial check
updateOverlay();
